import { IPhoneNumber, IPhoneNumberFullInfo } from '../../../../app.common/modules/common/models/phone-code.interface';

export interface IUser {
    id: number;
    isAuth: boolean;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: IPhoneNumberFullInfo;
    whatsAppNumber?: IPhoneNumberFullInfo;
    retailerStatus: number;
    showGetStarted: boolean;
    permission: number;
    viewedPrivacyNotification: boolean;
    currencyID: number;
    currencySign: string;
    countryID: number;
    countryName: string;
    languageID: number;
    retailerType: IRetailerType;
    isEmpty() : boolean;
    cleanUp() : void;
}

export enum IRetailerType {
    FULL = 0,
    LIGHT = 1,
    PUBLISHER = 2
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/account/model/iUser.ts